export default __webpack_public_path__ + "static/media/Colors_13.6cb7d135.png";